import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Check } from "lucide-react";

export default function EveryPenny() {
  const { ref, isVisible } = useScrollReveal();

  const features = [
    {
      title: "Smart detection finds matching uploads",
      description: "Even edited videos and partial clips.",
    },
    {
      title: "Automatic claims protect your content",
      description: "Content ID claims are filed when matching uploads are detected."
    },
    {
      title: "Revenue flows back to you",
      description: "Eligible reuploads can generate revenue using your content."
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 xxs:pb-0 xxs:py-12 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Section */}
          <div className="flex-1 flex flex-col gap-[27px] max-w-[702px]">
            {/* Numbered Badge */}
            <div className="bg-gradient-to-b from-[#8b5cf6] to-[#7336ff] rounded-[100px] w-[77px] h-[50px] flex items-center justify-center -mt-4 xxs:mt-24 xs:mt-24 sm:mt-24 md:mt-24 lg:mt-0">
              <p className="text-[32px] font-semibold text-white">01</p>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal enfinity-header-font" style={{ lineHeight: "1.2" }}>
              <span className="text-[#8b5cf6] enfinity-header-font">Your views belong to you</span>
              <span>, not content thieves</span>
            </h1>

            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font">
            Someone reuploads your video? We detect it with Content ID technology, automatically claim the video, and help the views generated from your content create value for you.
            </p>

            {/* Features List */}
            <div className="flex flex-col gap-[30px] max-w-[680px]">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#8b5cf6] rounded-[10px] w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <Check className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>

                  {/* Feature Content */}
                  <div className="flex flex-col gap-[10px]">
                    <p className="text-[24px] font-medium text-black leading-[35px] enfinity-header-font">
                      {feature.title}
                    </p>
                    <p className="text-[18px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-normal enfinity-subtext-font">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="lg:w-[420px] xl:w-[470px] 1xl:w-[520px] 2xl:w-[570px] flex-shrink-0 h-fit my-4 lg:pb-0 pb-24">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/thieves.png"
              alt="Shield Cards"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

